export const GET_DATA_PLATFORM_ADMINISTRATION = 'GET_DATA_PLATFORM_ADMINISTRATION'